import request from '@/utils/request';

// 查找学校
export function searchschoolApi(data) {
  return request({
    url: '/system/ext/university/search/school',
    method: 'POST',
    data
  })
}
// 根据学校搜索院系专业
export function searchcollegelApi(data) {
  return request({
    url: '/system/ext/university/search/college',
    method: 'POST',
    data
  })
}
// 根据学校搜索院系专业
export function searchoptionApi() {
  return request({
    url: '/system/ext/university/search/option',
    method: 'GET'
  })
}
// 根据父级id查找子级
export function searchchildApi(id) {
  return request({
    url: '/system/ext/university/search/' + id,
    method: 'GET'
  })
}